import api from "@/services/modules/addresses";
import { ADD_NEW_ADDRESS, UPDATE_ADDRESS } from "./action-types";
import { errorHandler } from "@/services/utils";

const actions = {
  async [ADD_NEW_ADDRESS]({ commit, dispatch }, newAddress) {
    try {
      const { data } = await api({ commit }).addNewAddress(newAddress);
      return data.id;
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  },
  async [UPDATE_ADDRESS]({ commit, dispatch }, updatedAddress) {
    try {
      await api({ commit }).updateAddress(updatedAddress);
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  }
};

export default {
  namespaced: true,
  actions
};
